import { Directive, ElementRef, Input, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[lazyLoad]'
})
export class LazyLoadDirective implements OnInit {
  @Input('lazyLoad') lazyLoadSrc!: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (this.el.nativeElement.tagName.toLowerCase() === 'img') {
              this.loadImage();
            } else {
              this.loadBackgroundImage();
            }
            observer.unobserve(this.el.nativeElement);
          }
        });
      }, options);

      observer.observe(this.el.nativeElement);
    } else {
      // Fallback for server-side rendering
      if (this.el.nativeElement.tagName.toLowerCase() === 'img') {
        this.loadImage();
      } else {
        this.loadBackgroundImage();
      }
    }
  }

  private loadImage() {
    this.renderer.setAttribute(this.el.nativeElement, 'src', this.lazyLoadSrc);
  }

  private loadBackgroundImage() {
    this.renderer.setStyle(
      this.el.nativeElement,
      'background-image',
      `url(${this.lazyLoadSrc})`
    );
  }
}